// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__fmNi8","empty":"ModalGraph_empty__1KfgF"};